// src/store/index.js
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import userReducer from './reducers/user';
import { PERSIST_CONFIG } from '../config/constants';
import { config } from '../config/env';

const persistConfig = {
  ...PERSIST_CONFIG,
  storage,
};

const rootReducer = combineReducers({
  user: persistReducer(persistConfig, userReducer),
});

const enhancer = config.isDevelopment
  ? composeWithDevTools(applyMiddleware(thunk))
  : applyMiddleware(thunk);

export const store = createStore(rootReducer, enhancer);

export const persistor = persistStore(store);

// Development debugging
if (config.isDevelopment) {
  window.__REDUX_STORE__ = store;
}